// src/components/InfoTooltip.js
import React from 'react';

const InfoTooltip = ({ content }) => {
  if (!content) return null;

  return (
    <span 
      className="info-tooltip-trigger"
      data-tooltip-id="app-tooltip"
      data-tooltip-html={content}
    >
      ?
    </span>
  );
};

export default InfoTooltip;